import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import store from './store/store'

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// Disable analytics
const updatedConfig = {
  ...awsconfig,
  Analytics: {
    disabled: true
  }
};

Amplify.configure(updatedConfig);

ReactDOM.render(<Provider store={store}><App/></Provider>, document.querySelector('#root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
